import { ConnectionTypeEnum } from "@api/rest/types-and-hooks";

/**
 * Auth0 connection types enabled on every organization created from Basecamp.
 *
 * Both are always enabled so the Google connection doesn't have to be turned on
 * by hand in Auth0 afterwards. username_password stays enabled because the
 * per-user invite type still defaults to it, and users can only be invited with
 * a connection type that is enabled on the org.
 */
export const ORG_CONNECTION_TYPES: ConnectionTypeEnum[] = [
  ConnectionTypeEnum.google_oauth,
  ConnectionTypeEnum.username_password,
];

/**
 * How the EHR sync gate behaves for an organization type (see `getEhrSyncMode`).
 *
 * - EDITABLE: any non-graduated type; `ehr_sync_enabled` is stored as sent.
 * - ALWAYS_ON: a graduated integration; the backend ignores the flag.
 * - UNSELECTED: no type chosen yet (create form only).
 */
export const EhrSyncMode = {
  EDITABLE: "editable",
  ALWAYS_ON: "always_on",
  UNSELECTED: "unselected",
} as const;
export type EhrSyncMode = (typeof EhrSyncMode)[keyof typeof EhrSyncMode];

/** A Frontera EHR org's vertical organization id (`external_id`) is a uuid; surrounding spaces are trimmed on save. */
export const VERTICAL_ORG_ID_PATTERN = /^\s*[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\s*$/i;

export const VERTICAL_ORG_ID_COPY = {
  label: "Vertical organization ID",
  help: "The organization's id in Frontera EHR (vertical). Programming syncs use it to find the right clinic.",
  invalid: "Vertical organization ID must be a UUID",
  saved: "Vertical organization ID updated",
  saveFailed: "Failed to update the vertical organization ID",
  noPermission: "Only Basecamp admins and enablement admins can change the vertical organization ID.",
};
